export const MESSAGE = {
  network_error:
    "Feature unavailable offline. Check your internet connection and try again.",
  provideWidgetConfig:
    "Failed to create widget configuration. Please ensure that the configuration object is correct.",
} as const;
